"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable  no-param-reassign */
var sortExperiencesByDate = function sortExperiencesByDate(experiences) {
  experiences.sort(function (a, b) {
    return Number(a.endYear) > Number(b.endYear);
  });
  var result = experiences.reduce(function (r, a) {
    r[a.endYear] = r[a.endYear] || [];
    r[a.endYear].push(a);
    return r;
  }, {});
  var experiencesReturn = [];
  Object.keys(result).map(function (key) {
    var arrayExperienceByYear = result[key];
    arrayExperienceByYear.sort(function (a, b) {
      return Number(a.endMonth) > Number(b.endMonth);
    });
    experiencesReturn = experiencesReturn.concat(arrayExperienceByYear);
    return experiencesReturn;
  });
  return experiencesReturn.reverse();
};
var _default = sortExperiencesByDate;
exports.default = _default;